import { StakingRewardsDto } from '../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import appContext from '../../../context/app/appContext';
import { getStakingRewardsTotal } from '../../../helpers/sdkHelper';
import { sleep } from '../../../web3/utils';

const useClaimableStakingRewards = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { mutate: globalMutate } = useSWRConfig();

    const { data, error, mutate } = useSWR(
        interfaceSDK && account ? ['claimableStakingRewards', account] : null,
        (_, userAddress) => interfaceSDK!.get.getClaimableStakingRewards(userAddress!)
    );

    const update = async (previousValue?: StakingRewardsDto) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (!currentValue) return;

            const currentTotal = getStakingRewardsTotal(currentValue);
            const previousTotal = getStakingRewardsTotal(previousValue);

            if (!previousTotal.eq(currentTotal)) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);

        //   when claimable staking rewards is updated, mutate claimed staking rewards.
        globalMutate(['claimedStakingRewards', account]);
    };

    return {
        claimableStakingRewards: data,
        isLoading: !error && !data,
        error,
        updateClaimableStakingRewards: update,
    };
};

export default useClaimableStakingRewards;
